module.exports = __webpack_public_path__ + "static/media/entranceA.e6a4ecc1.jpg";